import React from 'react'
import { useTranslation } from 'react-i18next'
import { FileCard } from '../FileCard'
import {
  CategoryHeader,
  CategoryTitle,
  CategoryCount,
} from './FileCategorySection.styles'
import type { FileCategorySectionProps } from './FileCategorySection.types'

// Map category keys to translation keys
const categoryTranslationMap: Record<string, string> = {
  'PDF Documents': 'files.categories.pdfDocuments',
  Spreadsheets: 'files.categories.spreadsheets',
  'CAD Files': 'files.categories.cadFiles',
  Images: 'files.categories.images',
  Documents: 'files.categories.documents',
  Other: 'files.categories.other',
}

export const FileCategorySection: React.FC<FileCategorySectionProps> = ({
  category,
  files,
  onClick,
  onDownload,
  onDelete,
  deletingFileId,
  onCancelDelete,
  onConfirmDelete,
}) => {
  const { t } = useTranslation('ui')

  const translatedCategory = categoryTranslationMap[category]
    ? t(categoryTranslationMap[category])
    : category

  return (
    <>
      <CategoryHeader>
        <CategoryTitle>{translatedCategory}</CategoryTitle>
        <CategoryCount>{files.length}</CategoryCount>
      </CategoryHeader>
      {files.map((file) => (
        <FileCard
          key={file.id}
          file={file}
          onClick={onClick}
          onDownload={onDownload}
          onDelete={onDelete}
          isDeleting={deletingFileId === file.id}
          onCancelDelete={onCancelDelete}
          onConfirmDelete={onConfirmDelete}
        />
      ))}
    </>
  )
}
